import {
  ApplicationCancelledNotification,
  ApplicationInvoiceIssuedNotification,
  ApplicationPendingApprovalNotification,
  EmployeeRemainingBalanceUpdatedNotificationDetailsDto,
  NotificationDetails,
  NotificationType,
  TenantPendingApprovalNotification,
  TenantWasUpdatedNotificationDto,
} from "../../requests/notification/dto";

export const isEmployeeRemainingBalanceUpdatedNotificationDetails =
  (type: NotificationType, details: NotificationDetails): details is EmployeeRemainingBalanceUpdatedNotificationDetailsDto =>
    type === NotificationType.EMPLOYEE_REMAINING_BALANCE_UPDATED;

export const isApplicationPendingApprovalNotificationDetails =
  (type: NotificationType, details: NotificationDetails): details is ApplicationPendingApprovalNotification =>
    type === NotificationType.APPLICATION_PENDING_APPROVAL;

export const isApplicationInvoiceIssuedNotificationDetails =
  (type: NotificationType, details: NotificationDetails): details is ApplicationInvoiceIssuedNotification =>
    type === NotificationType.APPLICATION_INVOICE_ISSUED;

export const isTenantPendingApprovalNotificationDetails =
  (type: NotificationType, details: NotificationDetails): details is TenantPendingApprovalNotification =>
    type === NotificationType.TENANT_PENDING_APPROVAL;

export const isApplicationCancelledNotificationDetails =
  (type: NotificationType, details: NotificationDetails): details is ApplicationCancelledNotification =>
    type === NotificationType.APPLICATION_CANCELLED;


export const isTenantUpdatedNotificationDetails =
  (type: NotificationType, details: NotificationDetails): details is TenantWasUpdatedNotificationDto =>
    type === NotificationType.TENANT_UPDATED;

export interface FormattedNotification {
  id: number;
  type: NotificationType;
  label: string;
  createdAt: Date;
  details: NotificationDetails;
  link?: string;
}
